import { Injectable, inject } from '@angular/core';
import { PendingDepositTransaction } from '../../interfaces/api/financial.interface';
import { GlobalService } from './global.service';
import { StorageService } from './storage.service';

export const STORAGE_KEY = 'zg_deposit_pending_transaction';

@Injectable({
  providedIn: 'root',
})
export class DepositPendingTransactionService {
  private readonly _storageService = inject(StorageService);
  private currentUserId: string | null = null;

  constructor(private _profileService: GlobalService) {
    this._profileService.profile.subscribe((profile) => (this.currentUserId = profile?._id ?? null));
  }

  public save(pending: PendingDepositTransaction): void {
    this._storageService.secureStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
  }

  public get(): PendingDepositTransaction | null {
    const storedValue = this._storageService.secureStorage.getItem(STORAGE_KEY);
    if (!storedValue) return null;

    try {
      const pending: PendingDepositTransaction = JSON.parse(storedValue);
      const isExpired = !pending?.expiresAt || pending.expiresAt <= Date.now();
      // Another user on this browser must never resume an account reserved by someone else.
      const isOwnedByAnotherUser =
        !pending?.registeredBy || pending.registeredBy !== this.currentUserId;
      if (isExpired || isOwnedByAnotherUser) {
        this.clear();
        return null;
      }
      return pending;
    } catch {
      this.clear();
      return null;
    }
  }

  public clear(): void {
    this._storageService.secureStorage.removeItem(STORAGE_KEY);
  }
}
